// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"b7d039bc","264":"903daf38","546":"da051fae","717":"bf5e7113"}[chunkId] + ".chunk.js";
};